const BASE = process.env.REACT_APP_API_URL || '/api';

async function request(path, options = {}) {
  const res = await fetch(`${BASE}${path}`, {
    headers: { 'Content-Type': 'application/json', ...options.headers },
    ...options
  });
  const data = await res.json();
  if (!data.success) throw new Error(data.message || 'Request failed');
  return data.data ?? data;
}

const CURRENT_USER = 'current-user';

// GET full profile data for a client
export function getProfileData(clientId) {
  return request(`/clients/${clientId}/profile-data`);
}

// Save client info responses
export function saveClientInfo(clientId, responses) {
  return request(`/clients/${clientId}/profile-data/client-info`, {
    method: 'PUT',
    body: JSON.stringify({ responses, userId: CURRENT_USER })
  });
}

// Save risk profile responses
export function saveRiskProfile(clientId, responses) {
  return request(`/clients/${clientId}/profile-data/risk`, {
    method: 'PUT',
    body: JSON.stringify({ responses, userId: CURRENT_USER })
  });
}

// Save goals
export function saveGoals(clientId, selectedGoals) {
  return request(`/clients/${clientId}/profile-data/goals`, {
    method: 'PUT',
    body: JSON.stringify({ selectedGoals, userId: CURRENT_USER })
  });
}

// Save assets
export function saveAssets(clientId, selectedAssetSubCategories, assetFieldResponses) {
  return request(`/clients/${clientId}/profile-data/assets`, {
    method: 'PUT',
    body: JSON.stringify({ selectedAssetSubCategories, assetFieldResponses, userId: CURRENT_USER })
  });
}

// Save liabilities
export function saveLiabilities(clientId, selectedLiabilitySubCategories, liabilityFieldResponses) {
  return request(`/clients/${clientId}/profile-data/liabilities`, {
    method: 'PUT',
    body: JSON.stringify({ selectedLiabilitySubCategories, liabilityFieldResponses, userId: CURRENT_USER })
  });
}

// Save preferences
export function savePreferences(clientId, selectedPreferences) {
  return request(`/clients/${clientId}/profile-data/preferences`, {
    method: 'PUT',
    body: JSON.stringify({ selectedPreferences, userId: CURRENT_USER })
  });
}

// Mark field as N/A
export function markFieldNa(clientId, fieldUid) {
  return request(`/clients/${clientId}/profile-data/fields/${fieldUid}/mark-na`, { method: 'POST' });
}

// Remove N/A from field
export function removeFieldNa(clientId, fieldUid) {
  return request(`/clients/${clientId}/profile-data/fields/${fieldUid}/mark-na`, { method: 'DELETE' });
}

// Add note on field
export function addFieldNote(clientId, fieldUid, note) {
  return request(`/clients/${clientId}/profile-data/fields/${fieldUid}/note`, {
    method: 'POST',
    body: JSON.stringify({ note })
  });
}

// Flag field for review
export function flagField(clientId, fieldUid) {
  return request(`/clients/${clientId}/profile-data/fields/${fieldUid}/flag`, { method: 'POST' });
}

// Remove flag from field
export function removeFieldFlag(clientId, fieldUid) {
  return request(`/clients/${clientId}/profile-data/fields/${fieldUid}/flag`, { method: 'DELETE' });
}

// Get risk score (read-only)
export function getRiskScore(clientId) {
  return request(`/clients/${clientId}/profile-data/risk-score`);
}

// Get completion percentages
export function getCompletion(clientId) {
  return request(`/clients/${clientId}/profile-data/completion`);
}
